/* Skinsation — quiz enhancement bundle.
   SINGLE entry point for all quiz enhancements, loaded by the
   `quiz_enhancements` custom-liquid section on templates/page.quiz.json.
   Pulls copy from assets/quiz-edu-data.js, whose URL it derives from its own
   src — so both files change without ever re-writing the 24KB template.

     1. AUTO-ADVANCE   one click per single-select question, Continue hidden
     2. CAPTURE        name/email step before results, with a Skip
     3. EDUCATION      Mei's personalised copy on the results screen
     4. LAYOUT         releases the fixed height, nav moves inside the panel
     5. ANALYTICS      dataLayer events for GA4 + the Omnisend result event

   All progressive enhancement: if this file fails, the quiz still works. */
(function () {

  var OMNISEND_FORM_ID = "6a76105ab539efdf9fadefa7";
  var CAPTURE_HEADING  = "Want these emailed to you?";
  var CAPTURE_SUB      = "We'll send your three, plus how to use them together.";
  var CAPTURE_BTN      = "EMAIL ME MY RESULTS";
  var CAPTURE_SKIP     = "No thanks, just show me";

  function formId() { return window.QUIZ_FORM_ID || OMNISEND_FORM_ID; }

  var me = document.currentScript;
  if (me && me.src && !window.SKIN_EDU) {
    var ds = document.createElement('script');
    ds.src = me.src.replace('quiz-autoadvance', 'quiz-edu-data');
    ds.onload = function () { if (window.__quizPaint) window.__quizPaint(); };
    document.head.appendChild(ds);
  }

  var CONCERN_BY_INDEX = ['acne','aging','hyperpigmentation','sensitivity','dryness','dullness','texture','none'];

  var SKIN_LABEL = {
    normal: 'normal', dry: 'dry', oily: 'oily',
    combination: 'combination', sensitive: 'sensitive'
  };
  var CONCERN_LABEL = {
    acne: 'breakouts',
    aging: 'fine lines & firmness',
    hyperpigmentation: 'dark spots & uneven tone',
    sensitivity: 'redness & sensitivity',
    dryness: 'dryness & dehydration',
    dullness: 'dullness & lack of glow',
    texture: 'texture & pores',
    none: 'keeping things simple'
  };

  var BRAND = '#b6666f', DEEP = '#8f4f57';

  function push(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: name }; for (var k in data) o[k] = data[k];
      window.dataLayer.push(o);
    } catch (e) {}
  }

  function styles() {
    if (document.getElementById('skin-edu-css')) return;
    var s = document.createElement('style');
    s.id = 'skin-edu-css';
    s.textContent =
      '.skin-edu{text-align:left}' +
      '.skin-edu__eyebrow{font-size:.68rem;letter-spacing:.14em;text-transform:uppercase;opacity:.6;margin:0 0 .15rem}' +
      '.skin-edu__h{font-size:1.15rem;font-weight:600;margin:0 0 .4rem;color:' + BRAND + '}' +
      '.skin-edu p.skin-edu__body{margin:0 0 1.1rem;line-height:1.6;font-size:.9rem}' +
      '.skin-edu__tips{border-top:1px solid rgba(0,0,0,.12);padding-top:.9rem}' +
      '.skin-edu__tips ul{margin:.35rem 0 0;padding-left:1.05rem;list-style:disc}' +
      '.skin-edu__tips li{margin:0 0 .45rem;line-height:1.55;font-size:.82rem;opacity:.85}' +
      /* Layout release. Deliberately UNQUALIFIED — the class is applied to the
         section root and every candidate wrapper. The theme sets `height` via
         `.section-quiz-<id>.active` and also puts Tailwind `overflow-hidden`
         on that same element: releasing the height WITHOUT the overflow (or
         vice versa) leaves content clipped and unscrollable. Always both. */
      '.quiz-results-open{height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important}' +
      '.quiz-results-open .quiz-answer,.quiz-results-open .answer-content-container{' +
        'height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important}' +
      '.quiz-results-open .answer-content-container{display:flex!important;flex-direction:column;padding:1.75rem 1.5rem 1.5rem}' +
      '.quiz-results-open .answer-container{max-height:none!important;height:auto!important;overflow:visible!important;align-items:start}' +
      '.quiz-results-open .answer-product-container{max-height:none!important;overflow:visible!important}' +
      '.quiz-results-open .answer-text-container{padding-right:1.5rem}' +
      '.quiz-results-open .quiz-nav{margin-top:1.75rem;padding:0!important}' +
      '.quiz-results-open [class*="quiz-pagination-"]{display:none!important}' +
      /* capture step */
      '.qz-cap{position:absolute;inset:0;z-index:40;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.97)}' +
      '.qz-cap__in{max-width:26rem;text-align:center;padding:1.5rem}' +
      '.qz-cap__h{font-size:1.5rem;font-weight:600;margin:0 0 .5rem;color:' + BRAND + '}' +
      '.qz-cap__p{font-size:.95rem;line-height:1.5;margin:0 0 1.5rem;opacity:.8}' +
      '.qz-cap__btn{display:inline-block;border:0;cursor:pointer;background:' + BRAND + ';color:#fff;' +
        'padding:.85rem 2rem;border-radius:10px;font-size:.8rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase}' +
      '.qz-cap__btn:hover{background:' + DEEP + '}' +
      '.qz-cap__skip{display:block;margin:1.1rem auto 0;background:none;border:0;cursor:pointer;' +
        'font-size:.82rem;text-decoration:underline;opacity:.65;color:inherit}' +
      '.qz-cap__note{font-size:.7rem;opacity:.55;margin:1.3rem 0 0;line-height:1.45}' +
      '@media (max-width:767px){' +
      '.quiz-results-open .answer-text-container{padding-right:0;padding-bottom:1.25rem}' +
      '.quiz-results-open .answer-content-container{padding:1.25rem 1rem}}';
    document.head.appendChild(s);
  }

  function esc(t) { return String(t).replace(/&(?!amp;)/g, '&amp;').replace(/</g, '&lt;'); }

  function init() {
    var sec = document.querySelector('.section-quiz');
    if (!sec) return;
    var roots = [sec];
    var cand = sec.querySelectorAll('[class*="section-quiz-"]');
    for (var ci = 0; ci < cand.length; ci++) roots.push(cand[ci]);
    if (sec.parentElement && /section-quiz/.test(sec.parentElement.className || '')) {
      roots.push(sec.parentElement);
    }
    var nav = sec.querySelector('[id^="x-quiz-nav-"]');
    if (!nav) return;
    styles();

    var navHome = { parent: nav.parentElement, next: nav.nextSibling };
    var DELAY = 260, lock = false;
    var captured = false, started = false;

    function nextButton() {
      var bs = nav.querySelectorAll('button');
      for (var i = 0; i < bs.length; i++) {
        var a = bs[i].getAttribute('@click.prevent') || bs[i].getAttribute('x-on:click.prevent') || bs[i].getAttribute('@click') || '';
        if (a.indexOf('next()') !== -1) return bs[i];
      }
      return null;
    }
    function advance() { var b = nextButton(); if (b && !b.disabled) b.click(); }

    function currentQuestion() {
      var qs = sec.querySelectorAll('.quiz-question');
      for (var i = 0; i < qs.length; i++) {
        if (qs[i].offsetParent === null) continue;
        if (getComputedStyle(qs[i]).position === 'absolute') continue;
        return qs[i];
      }
      return null;
    }
    function isSingle(q) { return !!q && q.getAttribute('data-question-type') === 'single'; }
    function isLast(q) { return !!q && (q.getAttribute('data-question-id') || '').indexOf('concern_') === 0; }

    function syncNav() {
      var btn = nextButton(); if (!btn) return;
      var q = currentQuestion();
      if (!q) return;   /* null mid-transition — recalculating made Continue flicker */
      btn.style.display = isSingle(q) ? 'none' : '';
    }

    /* ---------------- 2. CAPTURE ---------------- */
    function showCapture() {
      if (document.querySelector('.qz-cap')) return;
      var host = sec.querySelector('[id^="x-quiz-questions-container-"]') || sec;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var d = document.createElement('div');
      d.className = 'qz-cap';
      d.innerHTML =
        '<div class="qz-cap__in">' +
          '<p class="qz-cap__h">' + esc(CAPTURE_HEADING) + '</p>' +
          '<p class="qz-cap__p">' + esc(CAPTURE_SUB) + '</p>' +
          '<button type="button" class="qz-cap__btn">' + esc(CAPTURE_BTN) + '</button>' +
          '<button type="button" class="qz-cap__skip">' + esc(CAPTURE_SKIP) + '</button>' +
          '<p class="qz-cap__note">You\'ll join our email list. Unsubscribe any time.</p>' +
        '</div>';
      host.appendChild(d);
      push('quiz_capture_shown', {});

      d.querySelector('.qz-cap__btn').addEventListener('click', function () {
        try { window.omnisend = window.omnisend || []; omnisend.push(['openForm', formId()]); } catch (e) {}
        watchForSuccess();
      });
      d.querySelector('.qz-cap__skip').addEventListener('click', function () {
        push('quiz_capture_skipped', {});
        closeCapture(); advance();
      });
    }
    function closeCapture() { var d = document.querySelector('.qz-cap'); if (d) d.parentNode.removeChild(d); }

    /* Fallback for a silent omnisendForms event. Looks for OUR OWN success-step
       copy, which only exists after a real submit.

       DO NOT reintroduce a cookie check here. An earlier version treated an
       omnisend identity cookie as proof of submission — but Omnisend sets those
       for every visitor it already knows, so for any returning contact the very
       first poll matched and slammed the form shut before they could type. */
    function watchForSuccess() {
      var tries = 0, sawForm = false;
      var iv = setInterval(function () {
        if (captured || ++tries > 240) { clearInterval(iv); return; }
        var f = document.querySelector('[class*="omnisend-form"], [id*="omnisend-form"], .soundest-form');
        if (!f || f.offsetParent === null) return;
        if (!sawForm) { sawForm = true; return; }
        if (!/on its way|check your inbox/i.test(f.innerText || '')) return;
        clearInterval(iv);
        markCaptured();
        closeCapture();
        setTimeout(advance, 800);
      }, 500);
    }

    window.addEventListener('omnisendForms', function (e) {
      if (!e.detail) return;
      var t = e.detail.type;
      if (t !== 'submit' && t !== 'subscribed' && t !== 'success') return;
      markCaptured();
      closeCapture();
      setTimeout(advance, 400);
    });

    function markCaptured() {
      if (captured) return;
      captured = true;
      push('quiz_email_captured', {});
    }

    sec.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var opt = e.target.closest('.quiz-option');
      if (!opt || !sec.contains(opt)) return;
      var q = opt.closest('.quiz-question');
      if (!isSingle(q)) return;
      if (lock) return;
      lock = true;
      setTimeout(function () {
        if (isLast(q) && formId() && !captured) showCapture();
        else advance();
        setTimeout(function () { lock = false; syncNav(); }, 350);
      }, DELAY);
    });

    /* ---------------- 3/4. RESULTS ---------------- */
    function resultsOpen() {
      var a = sec.querySelector('[id^="x-quiz-answer-container-"]');
      return !!(a && a.offsetParent !== null);
    }
    function layout() {
      var open = resultsOpen();
      for (var ri = 0; ri < roots.length; ri++) {
        roots[ri].classList.toggle('quiz-results-open', open);
      }
      var panel = sec.querySelector('.answer-content-container');
      if (open) { if (panel && nav.parentElement !== panel) panel.appendChild(nav); }
      else if (nav.parentElement !== navHome.parent) navHome.parent.insertBefore(nav, navHome.next);
    }
    function chosen() {
      var opts = sec.querySelectorAll('.quiz-option');
      for (var i = 0; i < opts.length; i++) {
        var inner = opts[i].querySelector('.quiz-option__inner');
        if (!inner || inner.className.indexOf('selected') === -1) continue;
        var m = opts[i].className.match(/concern_([a-z]+)_o(\d+)/);
        if (m) return { skin: m[1], concern: CONCERN_BY_INDEX[parseInt(m[2], 10) - 1] };
      }
      return null;
    }

    /* Rough product-type label. Order matters: "Mild Sun Cream" is an SPF, not
       a moisturiser, so sun/SPF has to be tested before cream. */
    function productType(title) {
      var t = (title || '').toLowerCase();
      if (/\bsun\b|spf|uv /.test(t)) return 'SPF';
      if (/cleans|foam|face wash|mochi/.test(t)) return 'Cleanser';
      if (/toner/.test(t)) return 'Toner';
      if (/serum|essence|ampoule/.test(t)) return 'Serum';
      if (/cream|moistur|lotion|balm|gel/.test(t)) return 'Moisturiser';
      return 'Treatment';
    }

    function shownProducts() {
      var out = [], cards = sec.querySelectorAll('[id^="quiz-answer-product-list-"] .recommended-product');
      for (var i = 0; i < cards.length; i++) {
        if (getComputedStyle(cards[i]).display === 'none') continue;
        /* A card has SEVERAL /products/ links — the image wraps one and it has
           no text. Taking the first gave an empty title, which shipped an email
           with photos and no names. Take the link with the most text. */
        var links = cards[i].querySelectorAll('a[href*="/products/"]');
        var title = '', href = '';
        for (var j = 0; j < links.length; j++) {
          var txt = (links[j].innerText || links[j].textContent || '').trim();
          if (txt.length > title.length) title = txt;
          if (!href && links[j].href) href = links[j].href;
        }
        var img = cards[i].querySelector('img');
        if (!title && img) title = (img.getAttribute('alt') || '').trim();
        out.push({
          id: cards[i].id,
          title: title,
          type: productType(title),
          url: href,
          imageUrl: img ? img.src : ''
        });
      }
      return out;
    }
    function resultsUrl(prods) {
      var ids = [];
      for (var i = 0; i < prods.length; i++) if (prods[i].id) ids.push('id:' + prods[i].id);
      if (!ids.length) return '';
      return location.origin + '/search?type=product&q=' + encodeURIComponent(ids.join(' OR '));
    }

    function build(pick) {
      var D = window.SKIN_EDU; if (!D) return '';
      var e = D.edu[pick.skin]; if (!e) return '';
      var h = '<div class="skin-edu">';
      h += '<p class="skin-edu__eyebrow">Your skin</p>';
      h += '<p class="skin-edu__h">' + esc(e.name) + '</p>';
      h += '<p class="skin-edu__body">' + esc(e.intro) + '</p>';
      var c = e.c[pick.concern];
      if (c && pick.concern !== 'none') {
        h += '<p class="skin-edu__eyebrow">What you told us to focus on</p>';
        h += '<p class="skin-edu__h">' + (D.label[pick.concern] || '') + '</p>';
        h += '<p class="skin-edu__body">' + esc(c) + '</p>';
      }
      if (e.tips && e.tips.length) {
        h += '<div class="skin-edu__tips"><p class="skin-edu__eyebrow">From our team</p><ul>';
        for (var i = 0; i < e.tips.length; i++) {
          if (/^Tips to /i.test(e.tips[i])) continue;
          h += '<li>' + esc(e.tips[i]) + '</li>';
        }
        h += '</ul></div>';
      }
      return h + '</div>';
    }

    var writing = false, fired = false;
    function paint() {
      layout();
      if (resultsOpen() && !fired) {
        var pick0 = chosen(), prods = shownProducts();
        if (pick0 && prods.length) {
          fired = true;
          var url = resultsUrl(prods);
          push('quiz_complete', { skinType: pick0.skin, concern: pick0.concern, productCount: prods.length });
          /* PAYLOAD SHAPE — `origin` is read off the ENVELOPE, so the envelope
             is not the properties bag: properties belong under `properties`.
             Both shapes are sent because only one is documented. Verify with
             the "quiz skinType" diagnostic segment, not by eye. */
          try {
            var props = {
              captured: captured ? 'yes' : 'no',
              skinType: pick0.skin,
              concern: pick0.concern,
              skinLabel: SKIN_LABEL[pick0.skin] || pick0.skin,
              concernLabel: CONCERN_LABEL[pick0.concern] || pick0.concern,
              resultsUrl: url,
              products: prods
            };
            /* FLATTEN THE PRODUCTS. Omnisend merge tags resolve scalars fine
               ([[event.skinLabel]] renders) but will NOT do indexed array
               access — [[event.products.0.title]] renders as nothing at all,
               silently. `products` is kept for segmentation; the EMAIL must
               use these flat keys. */
            for (var pi = 0; pi < 3; pi++) {
              var pr = prods[pi] || {};
              props['product' + (pi + 1) + 'Title'] = pr.title || '';
              props['product' + (pi + 1) + 'Type']  = pr.title ? (pr.type || '') : '';
              props['product' + (pi + 1) + 'Url']   = pr.url || '';
              props['product' + (pi + 1) + 'Image'] = pr.imageUrl || '';
            }

            /* Mei's education copy, so the email can carry the same explanation
               the results page shows. Strings only — merge tags cannot reach
               into objects. `label` values are HTML-escaped in the data file,
               so unescape before sending or the email prints "&amp;". */
            var D = window.SKIN_EDU || {}, ed = (D.edu && D.edu[pick0.skin]) || {};
            function unesc(t) {
              return String(t || '').replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"');
            }
            props.skinName = unesc(ed.name);
            props.skinBlurb = unesc(ed.intro);
            props.concernHeading = pick0.concern === 'none' ? '' : unesc((D.label || {})[pick0.concern]);
            props.concernBlurb = pick0.concern === 'none' ? '' : unesc((ed.c || {})[pick0.concern]);

            var envelope = { origin: 'api', properties: props };
            for (var pk in props) { if (props.hasOwnProperty(pk)) envelope[pk] = props[pk]; }
            window.omnisend = window.omnisend || [];
            omnisend.push(['track', 'quiz completed', envelope]);
          } catch (err) {}
        }
      }
      if (writing) return;
      var box = sec.querySelector('[id^="quiz-answer-text-"]');
      if (!box || box.querySelector('.skin-edu')) return;
      var pick = chosen(); if (!pick) return;
      var html = build(pick); if (!html) return;
      writing = true;
      box.innerHTML = html;
      setTimeout(function () { writing = false; }, 60);
    }
    window.__quizPaint = paint;

    sec.addEventListener('click', function (e) {
      if (started) return;
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!b || !/button-quiz/.test(b.className)) return;
      started = true; push('quiz_start', {});
    }, true);

    try {
      new MutationObserver(function () { syncNav(); paint(); }).observe(sec, {
        attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class']
      });
    } catch (err) {}

    syncNav(); layout();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
